export default __webpack_public_path__ + "static/media/velaRed.2e49d1f2.png";